import React, {Component} from 'react'
import PropTypes from 'prop-types';

import './page.styl'

class Page extends Component {
    static propTypes = {
        className: PropTypes.string,
        header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        body: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
        footer: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    }

    updateSize() {
        const {page, pageBody, pageHeader = {clientHeight: 0}, pageFooter = {clientHeight: 0}} = this.refs;
        page && (pageBody.style.top = pageHeader.clientHeight + 'px')
        page && (pageBody.style.bottom = pageFooter.clientHeight + 'px')
        page && (pageBody.style.height = (page.clientHeight - pageHeader.clientHeight - pageFooter.clientHeight) + 'px')
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateSize.bind(this));
        this.updateSize()
    }

    componentWillUnmount() {
        this.updateSize()
        window.removeEventListener('resize', this.updateSize.bind(this));
    }

    componentDidUpdate() {
        this.updateSize();
    }

    render() {
        let {className=false, header= <div/>, body= <div/>, footer= <div/>} =  this.props;
        className = className ? 'page ' + className : 'page'

        return <div className={className} ref="page">
            <div className="page-body" ref="pageBody">
                {body}
            </div>
            <div className="page-footer" ref="pageFooter">
                {footer}
            </div>
            <div className="page-header" ref="pageHeader">
                {header}
            </div>
        </div>
    }
}

export default Page;
